import React from "react";
import { NavLink } from "react-router-dom";
import { Pages } from "../../utils/constants";
import VerticalDivider from "../Basic/VerticalDivider";
import Button from "../Basic/Button";
import heroImageSrc from "../../assets/illustrations/home-hero.svg";

const NumberBlock = ({ number, desc, className }) => {
  return (
    <div
      className={`space-y-2.5 border-l lg:border-0 pl-3 lg:pl-0 ${className}`}
    >
      <p className="text-8 header">{number}</p>
      <p className="text-sm text-gray-dark">{desc}</p>
    </div>
  );
};

const Hero = () => {
  return (
    <div className="px-5 lg:px-10 pt-8 lg:pt-4 pb-11 relative">
      <div className="w-full max-w-full lg:max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-20">
          <div className="flex flex-col lg:max-w-2xl">
            <h1 className="text-4xl lg:text-16 lg:text-16 lg:mt-14 mb-4 leading-tight header">
              A new era in{" "}
              <span className="whitespace-nowrap">outpatient care</span>
            </h1>

            <div className="flex max-w-full lg:hidden items-center justify-center mb-4">
              <img
                src={heroImageSrc}
                width="600"
                height="600"
                alt="hero"
                className="mx-auto max-w-[75vw] sm:max-w-md lg:max-w-full object-fill object-center"
                fetchpriority="high"
              />
            </div>

            <p className="text-lg lg:text-xl text-navy-medium mb-8">
              The first and only platform to grow your revenue while increasing
              your team’s efficiency with world class clinical AI.
            </p>
            <NavLink to={Pages.CONTACT}>
              <Button className="w-full sm:w-fit mb-8 lg:mb-16">
                Request demo
              </Button>
            </NavLink>

            <div className="w-full lg:grid grid-cols-13 flex flex-col gap-6 lg:gap-0">
              <NumberBlock
                number="7.5 min"
                desc="saved per encounter"
                className="whitespace-nowrap col-span-3"
              />
              <VerticalDivider className="hidden lg:block h-24 mx-auto" />
              <NumberBlock
                number="300+ hrs"
                desc="documentation time saved per provider per year"
                className="col-span-4"
              />
              <VerticalDivider className="hidden lg:block h-24 mx-auto" />
              <NumberBlock
                number="$750k+"
                desc="revenue generated per 1k enrolled patients"
                className="col-span-4"
              />
            </div>
          </div>

          <div className="hidden lg:flex max-w-full lg:max-w-2xl items-center justify-center">
            <img
              src={heroImageSrc}
              width="600"
              height="600"
              alt="hero"
              className="mx-auto max-w-[75vw] sm:max-w-md lg:max-w-full object-fill object-center"
              fetchpriority="high"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
